import {
  IsAnnualPlan,
  SbPaymentTrackingId,
  SubscriptionId,
  SubscriptionPaymentType,
  SubscriptionPlan,
  SubscriptionPlanAmount,
  SubscriptionPlanDocId,
  SubscriptionPlanId,
  SubscriptionStatus,
  SubscriptionWithMenu,
  SubscriptionWithMenuList,
  TrialDays,
  UserId,
} from '@raysee/domain';
import { SubscriptionMenu } from '@raysee/domain/src/subscription/subscriptionMenu';
import { SubscriptionMenuId } from '@raysee/domain/src/subscription/subscriptionMenuId';
import { SubscriptionPlanName } from '@raysee/domain/src/subscription/subscriptionPlanName';
import { SubscriptionRepository } from '../repository/subscriptionRepository';

export class SubscriptionGateway {
  subscriptionRepository = new SubscriptionRepository();
  getSubscWithMenuListByUserId = async (userId: UserId): Promise<SubscriptionWithMenuList> => {
    const firestoreSubscriptions = await this.subscriptionRepository.findByUserId(userId.value);
    return new SubscriptionWithMenuList(
      firestoreSubscriptions.map(
        (subscription) =>
          new SubscriptionWithMenu(
            new SubscriptionId(subscription.id),
            new UserId(subscription.userId),
            new SubscriptionMenu(
              new SubscriptionMenuId(subscription.menuId),
              new SubscriptionPlan(
                new SubscriptionPlanDocId(subscription.plan.id),
                new SubscriptionPlanId(subscription.plan.planId),
                new SubscriptionPlanAmount(subscription.plan.amount),
                new SubscriptionPlanName(subscription.plan.name),
                new TrialDays(subscription.plan.trial),
                new IsAnnualPlan(subscription.plan.isAnnual ?? false),
              ),
            ),
            subscription.sbInitialTrackingId ? new SbPaymentTrackingId(subscription.sbInitialTrackingId) : null,
            new SubscriptionStatus(subscription.status),
            new SubscriptionPaymentType(subscription.paymentType),
          ),
      ),
    );
  };
}
